import { ButtonProps } from 'antd';
import { StyledIconButton } from './IconButton.sc';

interface IconButtonProps extends ButtonProps {
  iconType?: 'normal' | 'danger';
}

const IconButton = ({ iconType = 'normal', ...buttonProps }: IconButtonProps) => {
  return <StyledIconButton size="small" shape="round" type="text" $iconType={iconType} {...buttonProps} />;
};

export default IconButton;
